// SetupStripePage.js
import { useEffect } from "react";
import { post } from "../network/api";
import { useSearchParams } from "react-router-dom";

const PaymentProfile = () => {
      const [searchParams] = useSearchParams();
  const stripeConnectAccountId = searchParams.get("id");
console.log("Stripe Connect Account ID:", stripeConnectAccountId);
  useEffect(() => {
    const createLink = async () => {
      try {
        const data = await post('customer/create-onboarding-link', {
            connect_id: stripeConnectAccountId
        });
        
        window.location.href = data.connect_id_url; // redirect to stripe onboarding
      } catch (err) {
        console.log(err);
      }
    };

    createLink();
  }, []);

  return (
    <div style={{ padding: 40 }}>
      <h6>Redirecting to Stripe… Please wait</h6>
    </div>
  );
}


export default PaymentProfile;